import { Collapse } from "antd"
import RichTextEditor from "../../RichTextEditor/RichTextEditor"
import { isEmptyRichText } from "../../RichTextEditor/richTextModel"

type Props = {
  termsAndConditions: string | undefined
  redesign?: boolean
}

const ProposalTermsAndConditions = ({ termsAndConditions, redesign = false }: Props) => {
  if (redesign && isEmptyRichText(termsAndConditions)) {
    return null
  }
  return <Collapse defaultActiveKey={1} style={{ marginBottom: '20px' }} items={[
    {
      key: 1,
      label: 'Terms and Conditions',
      children: <div style={{ width: '100%', padding: '12px 24px' }}>
        <RichTextEditor
          value={termsAndConditions ?? ''}
          disabled={true}
          removeToolbar={true} />
      </div>

    }
  ]} />
}

export default ProposalTermsAndConditions
